module.exports = __webpack_public_path__ + "img/folderFull.9bb7201a.svg";